<template>
  <v-card color="blue-grey" class="white--text" >    

    <v-card-title primary-title>
      <div>
        <div class="headline">Documentos de la comunidad</div>
        <span class="grey--text text--lighten-2">{{ carpeta }}</span>
      </div>
    </v-card-title>

    <div class="pa-2">
      <v-list two-line>
      <template v-for="documento in documentos">
        <v-list-tile 
          :key="documento.NOMBRE"
          :to="{ path: '/documentos/' + carpeta + '/' + documento.IDDOCUMENTO }">
          <!-- @click="verDocumento(documento.URL)"> -->
          

          <v-list-tile-action>

            <v-badge overlap color="red">
              <v-icon slot="badge" v-if="!documento.TS_LECTURA" dark>star</v-icon>
              <v-icon large>description</v-icon>
            </v-badge>
        
          </v-list-tile-action>
          
          <v-list-tile-content>
            <v-list-tile-title>{{ documento.NOMBRE }}</v-list-tile-title>            
            <v-list-tile-sub-title>{{ documento.FECHA | moment("LL")}}</v-list-tile-sub-title>
          </v-list-tile-content>

        </v-list-tile>
      </template>
    </v-list>
    </div>
  </v-card>
 </template>

<style>
</style>

<script>
  import { mapState } from 'vuex'
  import { DOCUMENTOS_REQUEST } from '../store/actions/documentos';

  export default {
    name: 'BrwDocumentos',
    props: {
      'carpeta': { type: String, required: true }
    },
    data: function () {
      return {}
    },
    created: function () {
      this.cargarDocumentos()
    },
    watch: {
      '$route': 'cargarDocumentos'
    },
    methods: {
      cargarDocumentos() {
        this.$store.dispatch(DOCUMENTOS_REQUEST, {
          idComunidad: this.$store.state.comunidades.idComunidadActiva,
          carpeta: this.carpeta
        })
      },
      verDocumento(url) {
        //@click="verDocumento(documento.URL)">
        window.location = url
      }
    },
    computed: {
      ...mapState({
        documentos: state => state.documentos.documentos
      })
    }
  }
</script>